import fetch from './fetch';

// 短信模板相关
const addSmsTemplate = ({ params }) => fetch({ url: '/add_sms_template', params, methold: 'post' });
const querSmsTemplate = () => fetch({ url: '/query_sms_template_list' });
const querSmsTemplateDetail = ({ id }) => fetch({ url: `/query_sms_template_detail/${id}` });
const searchSmsTemplate = ({ params }) => fetch({ url: '/search_sms_template', params });
const editSmsTemplate = ({ params }) => fetch({ url: '/edit_sms_template', params, methold: 'post' });
const smsTempType = () => fetch({ url: '/sms_temp_type_choose' });
// 组
const smsUserGroup = () => fetch({ url: '/sms_user_group_list' });
const groupInf = params => fetch({ url: `/sms_user_group_detail_list/${params.group_id}`, params });

// 短信
const sendMessage = ({ params }) => fetch({ url: '/pass_through_user_group_send_sms', params, methold: 'post' });
const smsRecordList = params => fetch({ url: `/query_send_sms_record/${params.group_id}`, params });
const smsRecordListDetail = params => fetch({ url: `/query_send_sms_detail_record/${params.sms_send_id}`, params });

// 重发
const getReSendInfo = ({ params }) => fetch({ url: `/send_another_sms_to_get_parameters/${params.group_id}`, params });
const getFailSendInfo = ({ params }) => fetch({ url: `/failed_sms_repeat_get_parameters/${params.group_id}`, params });

const groupDetail = params => fetch({ url: '/query_sms_user_group_user_detail', params });
export default {
  addSmsTemplate,
  querSmsTemplate,
  querSmsTemplateDetail,
  searchSmsTemplate,
  editSmsTemplate,
  smsTempType,
  smsUserGroup,
  groupInf,
  sendMessage,
  smsRecordList,
  smsRecordListDetail,
  getReSendInfo,
  getFailSendInfo,
  groupDetail
};
